import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import AdminSidebar from '../../components/sidebar/AdminSidebar';
import DeleteUnverifiedUsers from '../../components/admin/DeleteUnverifiedUsers';

const DeleteUnverifiedUsersPage: React.FC = () => {
  return (
    <DashboardLayout sidebar={<AdminSidebar />}>
      <div className="delete-unverified-users-page">
        <div className="page-header">
          <h2>Delete Unverified Users</h2>
          <p>Remove users who haven't verified their email addresses</p>
        </div>
        <DeleteUnverifiedUsers />
      </div>
    </DashboardLayout>
  );
};

export default DeleteUnverifiedUsersPage;
